(function () {

  function init() {

    function normalize(str) {
      return String(str || '').toLowerCase()
        .replace(/[-_]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function cardMatches(card, query) {
      if (!query) return true;
      var name    = normalize(card.getAttribute('data-app-name'));
      var desc    = normalize(card.getAttribute('data-app-desc'));
      var pricing = normalize(card.getAttribute('data-app-pricing'));
      return name.includes(query) || desc.includes(query) || pricing.includes(query);
    }

    function escHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    /* ── Search + dropdown ── */
    var input    = document.getElementById('hcCatSearch');
    var grid     = document.getElementById('hcCatGrid');
    var dropdown = document.getElementById('hcCatSearchDd');
    var countEl  = document.querySelector('.hc-cat-count');

    if (input && grid) {
      var cards      = Array.from(grid.querySelectorAll('[data-app-card]'));
      var totalCount = cards.length;

      function renderDropdown(query) {
        if (!dropdown) return;
        if (!query) {
          dropdown.classList.remove('is-open');
          dropdown.innerHTML = '';
          return;
        }

        var matched = cards.filter(function (card) {
          return cardMatches(card, query);
        });

        if (matched.length === 0) {
          dropdown.innerHTML = '<div class="hc-cat-search-dd-empty">No apps found for "' + escHtml(query) + '"</div>';
          dropdown.classList.add('is-open');
          return;
        }

        var html = '';
        matched.slice(0, 6).forEach(function (card) {
          var name    = card.getAttribute('data-app-name') || '';
          var pricing = card.getAttribute('data-app-pricing') || '';
          var imgEl   = card.querySelector('.pca-card__logo img');
          var btnEl   = card.querySelector('.pca-btn');
          var url     = btnEl ? btnEl.getAttribute('href') : '#';
          var imgSrc  = imgEl ? imgEl.getAttribute('src') : '';
          var initials = name.slice(0, 2).toUpperCase();

          html += '<a class="hc-cat-search-dd-item" href="' + escHtml(url) + '" target="_blank" rel="noopener">';
          html += '<div class="hc-cat-search-dd-thumb">';
          if (imgSrc) {
            html += '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(name) + '" width="32" height="32" loading="lazy">';
          } else {
            html += '<span style="font-size:11px;font-weight:700;color:#6b7280;">' + escHtml(initials) + '</span>';
          }
          html += '</div>';
          html += '<span class="hc-cat-search-dd-name">' + escHtml(name) + '</span>';
          if (pricing) {
            html += '<span class="hc-cat-search-dd-meta">' + escHtml(pricing) + '</span>';
          }
          html += '</a>';
        });

        dropdown.innerHTML = html;
        dropdown.classList.add('is-open');
      }

      function filterCards(query) {
        var visible = 0;
        cards.forEach(function (card) {
          var match = cardMatches(card, query);
          card.style.display = match ? '' : 'none';
          if (match) visible++;
        });
        if (countEl) {
          if (!query) {
            countEl.textContent = totalCount + ' app' + (totalCount !== 1 ? 's' : '');
          } else if (visible === 0) {
            countEl.textContent = 'No results for "' + query + '"';
          } else {
            countEl.textContent = visible + ' result' + (visible !== 1 ? 's' : '') + ' for "' + query + '"';
          }
        }
      }

      input.addEventListener('input', function () {
        var query = normalize(this.value.trim());
        filterCards(query);
        renderDropdown(query);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          this.value = '';
          filterCards('');
          if (dropdown) {
            dropdown.classList.remove('is-open');
            dropdown.innerHTML = '';
          }
        }
      });

      input.addEventListener('focus', function () {
        var query = normalize(this.value.trim());
        if (query) renderDropdown(query);
      });

      document.addEventListener('click', function (e) {
        if (!dropdown) return;
        if (!input.contains(e.target) && !dropdown.contains(e.target)) {
          dropdown.classList.remove('is-open');
        }
      });
    }

    /* ── Compare bar + modal ── */
    var bar       = document.querySelector('[data-compare-bar]');
    var cntEl     = document.querySelector('[data-compare-count]');
    var clearBtn  = document.querySelector('[data-compare-clear]');
    var openBtn   = document.querySelector('[data-compare-open]');
    var modal     = document.querySelector('[data-compare-modal]');
    var tableEl   = document.querySelector('[data-compare-table]');
    var closeBtns = document.querySelectorAll('[data-compare-close]');

    if (!bar) return;

    var selected = [];

    function updateBar() {
      cntEl.textContent = selected.length;
      bar.hidden = selected.length === 0;
      openBtn.disabled = selected.length < 2;
    }

    function buildTable() {
      if (selected.length < 2) return;
      var rows = [
        { label: 'Name',        key: 'name' },
        { label: 'Pricing',     key: 'pricing' },
        { label: 'Description', key: 'desc' }
      ];
      var html = '<table class="hc-table"><thead><tr><th>Feature</th>';
      selected.forEach(function (app) {
        html += '<th>' + escHtml(app.name) + '</th>';
      });
      html += '</tr></thead><tbody>';
      rows.forEach(function (row) {
        html += '<tr><td><strong>' + row.label + '</strong></td>';
        selected.forEach(function (app) {
          html += '<td>' + escHtml(app[row.key] || '—') + '</td>';
        });
        html += '</tr>';
      });
      html += '</tbody></table>';
      tableEl.innerHTML = html;
    }

    document.addEventListener('change', function (e) {
      var checkbox = e.target.closest('[data-compare-checkbox]');
      if (!checkbox) return;
      var card = checkbox.closest('[data-app-card]');
      if (!card) return;
      var appData = {
        name:    card.getAttribute('data-app-name') || '',
        pricing: card.getAttribute('data-app-pricing') || '',
        desc:    card.getAttribute('data-app-desc') || ''
      };
      if (checkbox.checked) {
        if (selected.length >= 3) {
          checkbox.checked = false;
          alert('You can compare up to 3 apps at a time.');
          return;
        }
        selected.push(appData);
      } else {
        selected = selected.filter(function (a) { return a.name !== appData.name; });
      }
      updateBar();
    });

    clearBtn && clearBtn.addEventListener('click', function () {
      selected = [];
      document.querySelectorAll('[data-compare-checkbox]').forEach(function (cb) {
        cb.checked = false;
      });
      updateBar();
    });

    openBtn && openBtn.addEventListener('click', function () {
      buildTable();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });

  } /* end init() */

  /* ── Wait for DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();